<template>
    <v-container :fluid="$vuetify.breakpoint.md" class="mb-12 mb-lg-0">
        <v-row justify="center">
            <v-col md="12">
                <v-list two-line>
                    <template v-for="(item, index) in items">
                        <v-list-item
                            :key="'N' + index"
                            :class="item.status === 0 ? 'v-list-item--active' : ''"
                            active-class="primary--text"
                            @click="getView(item)">
                            <v-list-item-avatar>
                                <v-icon class="secondary" dark>mdi-{{ item.icon }}</v-icon>
                            </v-list-item-avatar>

                            <v-list-item-content>
                                <v-list-item-title v-text="item.title"></v-list-item-title>
                                <v-list-item-subtitle v-text="item.content"></v-list-item-subtitle>
                            </v-list-item-content>

                            <v-list-item-action>
                                <v-list-item-action-text v-text="timeFormat(item.created_at)"></v-list-item-action-text>
                                <v-icon v-if="item.status === 0" color="secondary">mdi-check</v-icon>
                                <v-icon v-else color="success">mdi-check-all</v-icon>
                            </v-list-item-action>
                        </v-list-item>

                        <v-divider v-if="index < items.length - 1" :key="index"></v-divider>
                    </template>
                </v-list>
            </v-col>
            <v-dialog v-model="view" max-width="300">
                <v-card>
                    <v-card-title class="text-h6">{{ item.title }}</v-card-title>
                    <v-card-text>{{ item.content }}</v-card-text>
                    <v-card-actions>
                        <v-btn color="error" text @click="closeView">Cerrar</v-btn>
                        <v-spacer></v-spacer>
                        <v-btn v-if="item.link" color="primary" text :to="'/' + item.link">Ver</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-row>
    </v-container>
</template>

<script>
    import axios from 'axios';

    export default {
        name: "Notifications",
        props: [ 'user', 'items' ],
        data: () => ({
            loading: true,
            view: false,
            item: {}
        }),
        methods: {
            timeFormat(v) {
                const now = new Date();
                const date = new Date(v);
                const diffMs = now - date; // Diferencia en milisegundos
                const diffMin = Math.floor(diffMs / 60000); // Convertir a minutos
                const diffHr = Math.floor(diffMin / 60); // Convertir a horas

                if (diffMin < 1) {
                    return 'Ahora';
                } else if (diffMin < 60) {
                    return 'Hace ' + diffMin + ' min';
                } else if (diffHr < 24) {
                    return 'Hace ' + diffHr + ' horas';
                } else {
                    return v;
                }
            },
            getView(i) {
                this.item = i;
                this.view = true;

                if (i.status === 0) {
                    let formData = {id: i.id};
                    axios.post('/api/notifications', formData);
                    this.$emit('update');
                }
            },
            closeView() {
                this.view = false;
                this.item = {};
            }
        }
    }
</script>

<style scoped>

</style>
